export default {
  brand: "Stores",
  offers: "Offers and Flyers",
  products: "Products",
  showMoreOffers: "See all Offers and Flyers",
  showMoreProducts: "See all Products",
  showMoreBrands: "See all Stores"
}